function SmoothScroll() {
	// Charger la lib dans scripts-styles-queue.php pour activer le smooth scroll
	smoothScrollBarEnabled = typeof Scrollbar === "function";
	this.build();
	barbaCallbacks.push(this);
}

SmoothScroll.prototype.build = function () {
	if (!mobileCheck.isMobile && smoothScrollBarEnabled) {
		// Ajout de la classe smooth-scrollbar à la balise <html>
		document.documentElement.classList.add('smooth-scrollbar');
		const scrollContainer = document.querySelector('.smoothscroll-container');

		// Initialisation SmoothScrollbar
		scrollBar = Scrollbar.init(scrollContainer,
			{
				damping: 0.15,
				continuousScrolling: false,
				delegateTo: document
			}
		);

		// Liaison SmoothScrollbar et ScrollTrigger de gsap
		ScrollTrigger.scrollerProxy(document.body, {
			scrollTop() {
				return scrollBar.scrollTop;
			},
			scrollLeft() {
				return scrollBar.scrollLeft;
			}
		});
		scrollBar.addListener(function (status) {
			currentY = status.offset.y;
			scrollListener(currentY);
			ScrollTrigger.update();
		});

		const previousY = localStorage.getItem('currentScroll');
		if (devMode === 'true' && previousY) {
			setTimeout(function () {
				scrollBar.setPosition(0, previousY);
			}, 500);
		} else {
			scrollContainer.tabIndex = 1;
			scrollContainer.focus();
			setTimeout(function () {
				$(window).trigger('scrollBarRestoreDone');
			}, 200);
		}
	} else {
		window.onscroll = function () {
			currentY = window.scrollY;
			scrollListener(currentY);
		};
	}
};

SmoothScroll.prototype.destroy = function () {
	Scrollbar.destroyAll();
};
